import { render, staticRenderFns } from "./CalendarNew.vue?vue&type=template&id=154d2e02&scoped=true"
import script from "./CalendarNew.vue?vue&type=script&lang=js"
export * from "./CalendarNew.vue?vue&type=script&lang=js"
import style0 from "./CalendarNew.vue?vue&type=style&index=0&id=154d2e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154d2e02",
  null
  
)

export default component.exports